webpackJsonp([1],{

/***/ "+WJQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "68zB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/109b036ffc262.3031206.jpeg";

/***/ }),

/***/ "6gXb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing"}},[_c('div',{staticClass:"header-row"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"content"},[_vm._v("\n            HOMAM\n         ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F3GO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "GlAy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
   state: {},
   getters: {},
   mutations: {},
   strict: debug
}));

/***/ }),

/***/ "J5fL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__("lGUq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e128abd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__("6gXb");
function injectStyle (ssrContext) {
  __webpack_require__("h5Pi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e128abd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e128abd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae530534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("pA/R");
function injectStyle (ssrContext) {
  __webpack_require__("+WJQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae530534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash__ = __webpack_require__("NETs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate__);








var VueScrollTo = __webpack_require__("bm7V");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Vue plugins
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueScrollTo, {
   container: "#landing",
   duration: 2600,
   easing: "ease",
   offset: -60,
   force: true,
   cancelable: true,
   onStart: false,
   onDone: false,
   onCancel: false,
   x: false,
   y: true
});

// * Load Components *

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
   el: '#app',
   router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
   store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
   render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
   }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_Landing__ = __webpack_require__("J5fL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_site_e0__ = __webpack_require__("ZzFF");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
   routes: [{
      path: '/',
      name: 'Landing',
      component: __WEBPACK_IMPORTED_MODULE_2__components_site_Landing__["a" /* default */]
   }, {
      path: '/muktar',
      name: 'E0',
      component: __WEBPACK_IMPORTED_MODULE_3__components_site_e0__["a" /* default */]
   }, {
      path: '/mukhtar',
      redirect: '/muktar'
   }, {
      path: '*',
      redirect: '/'
   }],
   mode: 'history'
}));

/***/ }),

/***/ "ZzFF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_e0_vue__ = __webpack_require__("jZfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a58c280_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_e0_vue__ = __webpack_require__("iuoJ");
function injectStyle (ssrContext) {
  __webpack_require__("GlAy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a58c280"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_e0_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a58c280_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_e0_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h5Pi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iuoJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing"}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"picture"},[_c('img',{attrs:{"src":__webpack_require__("68zB"),"width":"219px","height":"256px"}})]),_vm._v(" "),_c('div',{staticClass:"profile"},[_c('div',{staticClass:"nametag"},[_c('div',[_vm._v("Muktar Homam")]),_vm._v(" "),_c('div',{staticClass:"tagline"},[_vm._v("CANDIDATE FOR PEO’S WEST-CENTRAL REGIONAL COUNCILLOR")])]),_vm._v(" "),_c('div',{staticClass:"highlights"},[_vm._v("\n               · Engineer, lecturer, and manager"),_c('br'),_vm._v("\n               · Experienced in interprovincial and international engineering practice"),_c('br'),_vm._v("\n               · Holder of bachelor’s, master’s, and a doctorate in civil engineering"),_c('br'),_vm._v("\n               · Holder of an MBA, specializing in economics and public management"),_c('br'),_vm._v("      \n               · Practitioner and business owner"),_c('br'),_vm._v("\n               · PEO member since 2004"),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(" PEO Election ")]),_vm._v(" "),_c('div',{staticClass:"sub-section"},[_c('h4',[_vm._v(" Message ")]),_vm._v(" "),_c('ul',[_c('a',{attrs:{"href":"https://www.peo.on.ca/sites/default/files/2020-01/Homam-Statement2020.pdf"}},[_vm._v("· Candidate Statement "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.peo.on.ca/sites/default/files/2020-01/Homam-AdditionalStatement2020.pdf"}},[_vm._v("· Why am I standing as a Candiate? "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://drive.google.com/file/d/1HAKVUN2-o8WK14Ph-ldTOOVPKIgpCxtR/view?usp=sharing"}},[_vm._v("· What are we voting for? "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://drive.google.com/file/d/1nbscFwEML7ka27rjWjxZPHj5eIHs-kxb/view?usp=sharing"}},[_vm._v("· Why is it very important to vote in 2020? "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br')]),_vm._v(" "),_c('h4',[_vm._v(" Election Debate ")]),_vm._v(" "),_c('ul',[_c('a',{attrs:{"href":"https://webcast.fmav.ca/PEO2020WCR/index.php?enter"}},[_vm._v("· Election Debate Webcast, Video – Full Debate (40min) "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://drive.google.com/file/d/0BwIm2n0NLjRPUnNzM19FX1J1cldnSU5kZ1A2WElzdlR3Q1ow/view?usp=sharing"}},[_vm._v("· Opening statement, audio – (2min) "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://drive.google.com/file/d/0BwIm2n0NLjRPZWRYcVdBa3J6ZmIyQmRTXzlmQ0dtWWd6SXJZ/view?usp=sharing"}},[_vm._v("· Closing statement, audio – (1.5min) "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://drive.google.com/file/d/0BwIm2n0NLjRPRllZQ0dFTVFKZEJibXJKemdsTzVGSXZhYlk0/view?usp=sharing"}},[_vm._v("· Position on chapters, audio – (1.0 min) "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://drive.google.com/file/d/0BwIm2n0NLjRPWHVGWW5jdGxKdVpIWnFGSURRajBnSU15eG5R/view?usp=sharing"}},[_vm._v("· What members need to know, audio – (2.5 min) "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br')])]),_vm._v(" "),_c('h3',[_vm._v(" Activities ")]),_vm._v(" "),_c('ul',[_vm._v("\n            · Nominee – Alumni Member for University of Toronto’s Governing Council"),_c('br'),_vm._v("\n            · Nominee – President, Society of Professional Engineers & Associates"),_c('br'),_vm._v("\n            · Member – Academic Council of Department of Civil Engineering, UofT"),_c('br'),_vm._v("\n            · Chair – Students Committee, Innovative System and Intelligent Structures"),_c('br'),_vm._v("\n            · Mentor – Faculty of Applied Science and Engineering, UofT"),_c('br')]),_vm._v(" "),_c('h3',[_vm._v(" Professional Experience ")]),_vm._v(" "),_c('ul',[_vm._v("\n            · Managing Director – Homam Consulting & Business Solutions"),_c('br'),_vm._v("\n            · Senior Structural Engineer – Candu Energy Inc."),_c('br'),_vm._v("\n            · Senior Structural Engineer – Atomic Energy of Canada Limited"),_c('br'),_vm._v("\n            · Senior Structural Engineer -  SNC Lavalin Nuclear"),_c('br'),_vm._v("\n            · Civil/Structural Engineer – Klohn Crippen Berger Ltd"),_c('br'),_vm._v("\n            · Lecturer/Adjunct – Department of Civil Engineering, UofT"),_c('br'),_vm._v("\n            · Research and Teaching Assistant – Department of Civil Engineering, UofT"),_c('br'),_vm._v("\n            · Visiting Researcher – Ontario Power Generation/Kinectrics"),_c('br'),_vm._v("\n            · Visiting Researcher – National Research Council – Institute for Research in Construction"),_c('br'),_vm._v("\n            · Program Coordinator – Norwegian Afghanistan Committee"),_c('br')]),_vm._v(" "),_c('h3',[_vm._v(" Articles ")]),_vm._v(" "),_c('ul',[_vm._v("\n            [1] "),_c('a',{attrs:{"href":"http://individual.utoronto.ca/homam/Toronto%20Traffic%20Congestion.pdf"}},[_vm._v("Toronto's Traffic Congestion "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v("\n            [2] "),_c('a',{attrs:{"href":"http://individual.utoronto.ca/homam/unionized_seniority.pdf"}},[_vm._v("Performance-Based Seniority in Unionized Labour Force "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v("\n            [3] "),_c('a',{attrs:{"href":"http://individual.utoronto.ca/homam/21CenturyWorkersStrike.pdf"}},[_vm._v("Strike by Workers of 21st Century "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v("\n            [4] "),_c('a',{attrs:{"href":"http://individual.utoronto.ca/homam/KnoweldgeWorkersSeniority.pdf"}},[_vm._v("Seniority Protection for Unionized Knowledge Workers and its Effects on Worker Motivation and Organizational Efficiency "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v("\n            [5] "),_c('a',{attrs:{"href":"http://individual.utoronto.ca/homam/Labour_Relations_Knowledge_Workers.pdf"}},[_vm._v("Labour Relation and Role of Strike in 21st Century "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v("\n            [6] "),_c('a',{attrs:{"href":"http://individual.utoronto.ca/homam/CPP_benfits.pdf"}},[_vm._v("Pension Plan Benefits Should Be Enhanced, and here is Why "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v("\n            [7] "),_c('a',{attrs:{"href":"http://individual.utoronto.ca/homam/Carbon_tax_versus_cap__trade.pdf"}},[_vm._v("Economic Efficiency of Carbon Tax versus Carbon Cap-and-Trade "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v("\n            [8] "),_c('a',{attrs:{"href":"http://individual.utoronto.ca/homam/Review_Saskatchewan_White_Paper.pdf"}},[_vm._v("A Strong Case for Carbon Tax – Saskatchewan’s Climate Change White Paper "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br'),_vm._v("\n            [9] "),_c('a',{attrs:{"href":"http://individual.utoronto.ca/homam/Carbon_Tax_Is_the_Good_Tax_Coming_%20to_%20G7_%20Countries.pdf"}},[_vm._v("Carbon Tax Is the Good Tax and Is Coming to a G7 Country near You "),_c('img',{attrs:{"src":__webpack_require__("F3GO"),"width":"16px","height":"12.5px"}})]),_c('br')]),_vm._v(" "),_c('h3',[_vm._v(" Publications ")]),_vm._v("\n         * FRP = FIBRE REINFORCED POLYMERS\n         "),_c('ul',[_vm._v("\n            · DURABILITY OF FRPs USED IN CONCRETE STRUCTURES - M.A.S.C THESIS (2000)"),_c('br'),_vm._v("\n            · FRPs AND FRP-CONCRETE COMPOSITES SUBJECTED TO VARIOUS LOADS AND ENVIRONMENTAL EXPOSURES - PH.D. THESIS (2005)"),_c('br'),_vm._v("\n            · DURABILITY OF FRPs USED IN CONCRETE STRUCTURES (2000)"),_c('br'),_vm._v("\n            · DURABILITY OF FRP WRAPS AND EXTERNAL FRP-CONCRETE BOND (2001)"),_c('br'),_vm._v("\n            · A DECADE OF PERFORMANCE OF FRP-REPAIRED CONCRETE STRUCTURES (2004)"),_c('br'),_vm._v("\n            · A DECADE OF PERFORMANCE OF FRP-REPAIRED CONCRETE STRUCTURES (2004)"),_c('br'),_vm._v("\n            · DURABILITY OF FRPs EXPOSED TO HIGH TEMPERATURES AND GAMMA RADIATION (2007)"),_c('br'),_vm._v("\n            · LONG-TERM PERFORMANCE MONITORING OF GFRPREPAIRED BRIDGE COLUMNS (2007)"),_c('br'),_vm._v("\n            · DURABLE RETROFITTING OF CONCRETE STRUCTURES (2010)"),_c('br'),_vm._v("\n            · FRPs EXPOSED TO NUCLEAR POWER PLANT ENVIRONMENT (2013)"),_c('br')]),_vm._v(" "),_c('h3',[_vm._v(" Field and Survey Reports ")]),_vm._v(" "),_c('ul',[_vm._v("\n            · BASELINE SURVEY OF ZEEBAK, ESHKASHEM AND SEHGHNAN DISTRICTS, BADAKHSHAN, AFGHANISTAN, HOMAM, SAYED MUKHTAR (1994)"),_c('br')]),_vm._v(" "),_c('h3',[_vm._v(" Other Publications ")]),_vm._v(" "),_c('ul',[_vm._v("\n            · NORTHERN ONTARIO HYDROELECTRIC DEVELOPMENT POTENTIAL - MINISTRY OF ENERGY, ONTARIO, CANADA (2005)"),_c('br'),_vm._v("\n            · ALBANY RIVER HYDROELECTRIC POTENTIAL - MINISTRY OF ENERGY, ONTARIO, CANADA (2005)"),_c('br')])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jZfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'Landing',
   data: function data() {
      return {
         msg: '',
         copyrightYear: new Date().getFullYear(),
         investorLabelVisible: true,
         investorContactVisible: false
      };
   },

   computed: {},
   methods: {
      preventMouseDown: function preventMouseDown(e) {}
   }
});

/***/ }),

/***/ "lGUq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'Landing',
   data: function data() {
      return {
         msg: '',
         copyrightYear: new Date().getFullYear(),
         investorLabelVisible: true,
         investorContactVisible: false
      };
   },

   computed: {},
   methods: {
      preventMouseDown: function preventMouseDown(e) {}
   }
});

/***/ }),

/***/ "pA/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'app',
   data: function data() {
      return {
         msg: 'Homam.'
      };
   }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d292c52275e085a2bca2.js